/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["hr[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:10px}[_nghost-%COMP%]     .remax-select{display:flex;justify-content:space-between}[_nghost-%COMP%]     label, label[_ngcontent-%COMP%]{font-weight:700;font-size:1.5rem;text-transform:capitalize;color:#20222a;-ms-grid-row-align:center;align-self:center}app-switch[_ngcontent-%COMP%]     label{font-size:inherit;font-weight:400}app-switch[_ngcontent-%COMP%]     div.full-width{margin-bottom:10px}"];
export { styles as styles };
